import React, { useRef } from 'react';
import { Button } from '@spark-labs/avocado-ui';

interface UploadButtonProps {
  onFilesChange: (files: FileList) => void;
  accept?: string;
  render?: (upload: () => void) => JSX.Element;
  singleUpload?: boolean;
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  children,
  onFilesChange,
  accept,
  render,
  singleUpload,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length && inputRef.current) {
      onFilesChange(e.target.files);
      /**
       * If this is enabled, you won't be able to get a filelist, you can only upload one
       * file, the input resets after the file is sent via props handler
       */
      if (singleUpload) {
        inputRef.current.value = '';
      }
    }
  };

  const handleUpload = () => {
    if (inputRef.current) {
      const ref = inputRef.current;
      ref.click();
    }
  };

  const renderChildren = () => {
    if (render) {
      return render(handleUpload);
    } else {
      return (
        <Button className="w-full bg-blue-dark py-2 px-3 text-white" onClick={handleUpload}>
          {children}
        </Button>
      );
    }
  };
  return (
    <>
      <label htmlFor="upload-button">
        <input
          type="file"
          ref={inputRef}
          accept={accept}
          style={{ display: 'none' }}
          onChange={handleChange}
        />
        {renderChildren()}
      </label>
    </>
  );
};
